import { render, staticRenderFns } from "./GroupedProductsModal.vue?vue&type=template&id=28034b94"
import script from "./GroupedProductsModal.vue?vue&type=script&lang=js"
export * from "./GroupedProductsModal.vue?vue&type=script&lang=js"
import style0 from "./GroupedProductsModal.vue?vue&type=style&index=0&id=28034b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports